import Vue from 'vue';
import Fragment from 'vue-fragment';
import Vue2TouchEvents from 'vue2-touch-events';
import i18n from './i18n';

Vue.use(Fragment.Plugin);
Vue.use(Vue2TouchEvents);

export const plugins = { i18n };
